<h2 mat-dialog-title>
    <mat-icon>lock_clock</mat-icon>
    &nbsp;Session Expired
</h2>
<div mat-dialog-content>
    <mat-card>
        <mat-card-content>
            <p>
                Your session has expired. Click
                <strong>Log In</strong>
                to continue where you left off.
            </p>
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
            <button color="primary" mat-flat-button (click)="login()" [disabled]="loading()">
                @if (loading()) {
                    <mat-spinner diameter="18" style="display: inline-block; margin-right: 6px"></mat-spinner>
                } @else {
                    <mat-icon>login</mat-icon>
                }
                Log In
            </button>
        </mat-card-actions>
    </mat-card>
</div>
